import React from 'react';

const ProtocolsTab = ({ protocols, loading, searchQ }) => (
  <div data-testid="protocols-tab">
    {loading && <div style={{ color: '#71717a', textAlign: 'center', padding: 40 }}>Loading protocols...</div>}
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 12 }}>
      {protocols.filter(p => !searchQ || p.name.toLowerCase().includes(searchQ.toLowerCase())).map(p => (
        <div key={p.id} className="ocean-shimmer shimmer-border" style={{
          background: '#475569', borderRadius: 12, padding: 16, position: 'relative',
          border: '1px solid rgba(252, 211, 77,0.15)', overflow: 'hidden'
        }}>
          <div style={{ position: 'relative', zIndex: 4 }}>
            <h4 style={{ margin: '0 0 4px', color: '#334155', fontSize: '0.9rem' }}>{p.name}</h4>
            <p style={{ color: '#71717a', fontSize: '0.72rem', margin: '0 0 6px' }}>{p.description || 'No description'}</p>
            <div style={{ display: 'flex', gap: 10, fontSize: '0.68rem', color: '#a1a1aa', marginBottom: 8 }}>
              <span>by {p.creator_name}</span>
              <span>{p.copies} copies</span>
              {p.rating > 0 && <span style={{ color: '#047857' }}>{'*'.repeat(Math.round(p.rating))} ({p.review_count})</span>}
            </div>
            <span style={{ background: 'rgba(16,185,129,0.2)', color: '#10b981', padding: '3px 10px', borderRadius: 8, fontSize: '0.72rem', fontWeight: 700 }}>FREE</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default ProtocolsTab;
